<template>
<div id="no-results" class="all-100 vertical-space align-center">
    <div class="no-results">
        <h3 class="section-title">{{ title }}</h3>
            <p v-html="message"></p>
        <slot name="extra_slot"></slot>
    </div>
</div>
</template>

<script>
export default {
    props:{
        title: {
            type: String,
            default:"Pesquisa sem resultados"
        },
        message: {
            type: String,
            default:"Experimente selecionar menos filtros para conseguir mais resultados."
        },
    }
};
</script>
